function record(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : null
}

export function apiKeyErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message
  const payload = record(error)
  const data = record(payload?.['data'])
  const messages = data?.['messages']
  if (Array.isArray(messages) && typeof messages[0] === 'string') return messages[0]

  const errors = record(data?.['errors'])
  if (errors) {
    for (const value of Object.values(errors)) {
      if (Array.isArray(value) && typeof value[0] === 'string') return value[0]
    }
  }
  return 'The API key request failed. Try again.'
}
